var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{key:_vm.language,attrs:{"id":"app","data-app":"true"}},[_c('Alerts'),_c('OrgSwitchPromptDialog',{attrs:{"data-testid":"app-dialog-orgSwitchPrompt"}}),_c('OrgSwitchLoadingScreen',{attrs:{"data-testid":"app-screen-orgSwitchLoading"}}),(_vm.layout === _vm.$constants.layouts.blank)?_c('BlankLayout'):_c('DefaultLayout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }